/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dateTime: NonNullable<unknown> }} Coinvestments_Draftemail_Scheduledarialabel4Inputs */

const en_coinvestments_draftemail_scheduledarialabel4 = /** @type {(inputs: Coinvestments_Draftemail_Scheduledarialabel4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scheduled, sends ${i?.dateTime}`)
};

/**
* | output |
* | --- |
* | "Scheduled, sends {dateTime}" |
*
* @param {Coinvestments_Draftemail_Scheduledarialabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_scheduledarialabel4 = /** @type {((inputs: Coinvestments_Draftemail_Scheduledarialabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Scheduledarialabel4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_scheduledarialabel4(inputs)
});
export { coinvestments_draftemail_scheduledarialabel4 as "coInvestments_draftEmail_scheduledAriaLabel" }